"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var STRING_COLLATOR = window.Intl && (0, _typeof2.default)(window.Intl) === 'object' && new Intl.Collator();

var _default = function _default(option1, option2) {
  var option1Text = option1.text;
  var option2Text = option2.text;
  var comparisonResult = 0;

  if (STRING_COLLATOR) {
    comparisonResult = STRING_COLLATOR.compare(option1Text, option2Text);
  } else if (option1Text > option2Text) {
    comparisonResult = 1;
  } else if (option2Text > option1Text) {
    comparisonResult = -1;
  }

  return comparisonResult;
};

exports.default = _default;
module.exports = exports.default;